import React, { Fragment, useEffect, useState } from "react";
import styles from "Components/Topology/topology.module.scss";
import { Form, Select, Row, Col, Divider, InputNumber } from "antd";
import { useAppSelector } from "store/hook";
import { setFields, SYSTEMProps } from "./setField";

const { Option } = Select;

// alarm type DI 跟設備 system 的 Dying Gasp 不能同時 enable
const M335Type = [
  { value: "sms", name: "SMS" },
  { value: "vpn-disconnect", name: "VPN disconnect" },
  { value: "wan-disconnect", name: "WAN disconnect" },
  { value: "lan-eth-disconnect", name: "LAN disconnect" },
  { value: "reboot", name: "Reboot" },
  { value: "lan-wifi-disconnect", name: "AP lost all" },
  { value: "di", name: "DI" },
];
// for M335-W-A
const M335_A_Type = [
  { value: "vpn-disconnect", name: "VPN disconnect" },
  { value: "wan-disconnect", name: "WAN disconnect" },
  { value: "lan-eth-disconnect", name: "LAN disconnect" },
  { value: "reboot", name: "Reboot" },
  { value: "lan-wifi-disconnect", name: "AP lost all" },
  { value: "di", name: "DI" },
];
// for M335-W6
const M335_W6Type = [
  { value: "sms", name: "SMS" },
  { value: "vpn-disconnect", name: "VPN disconnect" },
  { value: "wan-disconnect", name: "WAN disconnect" },
  { value: "lan-eth-disconnect", name: "LAN disconnect" },
  { value: "reboot", name: "Reboot" },
  { value: "lan-wifi-disconnect", name: "AP lost all" },
  { value: "di", name: "DI" },
  { value: "geofence", name: "Geofence" },
  { value: "health-check", name: "Health Check" },
];
const AlarmM335 = React.memo(({ SubmitConfigonFinish, form }: SYSTEMProps) => {
  const [AlarmEnable, setAlarmEnable] = useState<boolean>(false);
  const [AlarmType, setAlarmType] = useState<string[]>([]);

  const [GPSReference, setGPSReference] = useState(false);

  const { formData, importSource, selectedModel } = useAppSelector((state) => state.topology);
  const alarm = formData?.system?.alarm;
  useEffect(() => {
    setAlarmEnable(alarm?.mode || false);
    setGPSReference(alarm?.geofence?.auto_detect);
    setAlarmType(alarm?.inputs);

    if (importSource === "NewConfig") {
      return;
    }

    setFields(alarm, form);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formData]);

  return (
    <Form onFinish={SubmitConfigonFinish} form={form} scrollToFirstError layout="vertical">
      <div className="formwrap">
        <Row gutter={24} justify="space-around">
          <Col xs={24} sm={24} md={24} lg={24} xl={10}>
            <h2>Type</h2>
            <Divider className={styles.divider} />
            <Form.Item
              name={"alarm_enabled"}
              label="Alarm Enable"
              rules={[{ required: true, message: "required!" }]}
              initialValue={false}
              // dependencies={['alarm_input']}
            >
              <Select
                onChange={(value: any) => {
                  setAlarmEnable(value);
                  form.validateFields(["alarm_input", "gps_radius", "gps_latitude", "gps_longitude"]);
                }}
                placeholder={"ON/OFF"}
              >
                {/* @ts-ignore */}
                <Option key={0} value={true}>
                  ON
                </Option>
                {/* @ts-ignore */}
                <Option key={1} value={false}>
                  OFF
                </Option>
              </Select>
            </Form.Item>

            <Form.Item
              name={"alarm_input"}
              label="Type"
              rules={[{ required: AlarmEnable, message: "required!" }]}
              initialValue={selectedModel === "M335-W-A" ? ["vpn-disconnect"] : ["sms"]}
              // validateTrigger={['alarm_enabled']}
            >
              <Select
                onChange={(value: string[]) => {
                  setAlarmType(value);
                }}
                mode="multiple"
                maxTagCount={"responsive"}
                placeholder={"DI , Reboot ...."}
                disabled={!AlarmEnable}
              >
                {(() => {
                  let options: { value: string; name: string }[] = [];
                  if (selectedModel === "M335-W-A") options = M335_A_Type ?? [];
                  else if (selectedModel === "M335-W") options = M335Type ?? [];
                  else if (selectedModel === "M335-W6") options = M335_W6Type ?? [];

                  return options.map((item, index) => {
                    // 如果有條件要排除可以放在這裡
                    // if (item.value === "geofence" && !hasGPS) return null;
                    return (
                      <Option key={index} value={item.value}>
                        {item.name}
                      </Option>
                    );
                  });
                })()}
              </Select>
            </Form.Item>
          </Col>
          {selectedModel === "M335-W6" ? (
            <Col xs={24} sm={24} md={24} lg={24} xl={10}>
              <h2>GPS Detection</h2>
              <Divider className={styles.divider} />
              <Form.Item
                name={"gps_radius"}
                label="Radius(m)"
                rules={[
                  {
                    required: AlarmType?.includes("geofence") && AlarmEnable,
                    message: "required!",
                  },
                  {
                    type: "number",
                    max: 100000,
                    min: 100,
                    message: "Radius range should be 100-100000",
                  },
                ]}
                initialValue={150}
                tooltip={"Issue an alert when device is out of range"}
              >
                <InputNumber
                  style={{ width: "100%" }}
                  placeholder="100~100000"
                  disabled={!AlarmEnable || !AlarmType?.includes("geofence")}
                />
              </Form.Item>

              <Form.Item
                name="gps_reference"
                label="Reference"
                rules={[
                  {
                    required: AlarmType?.includes("geofence"),
                    message: "required!",
                  },
                ]}
                initialValue={true}
                tooltip={"Setting device location by manual input/Auto detect by GPS"}
              >
                <Select
                  disabled={!AlarmEnable || !AlarmType?.includes("geofence")}
                  onChange={(value: any) => {
                    setGPSReference(value);
                  }}
                  placeholder={"Manual/Auto"}
                >
                  {/* @ts-ignore */}
                  <Option key={0} value={true}>
                    Auto Detect
                  </Option>
                  {/* @ts-ignore */}
                  <Option key={1} value={false}>
                    Self Define
                  </Option>
                </Select>
              </Form.Item>
              {GPSReference === false && (
                <Fragment>
                  <Form.Item
                    name={"gps_latitude"}
                    label="Latitude"
                    rules={[
                      {
                        required: AlarmType?.includes("geofence") && AlarmEnable,
                        message: "required!",
                      },
                      {
                        type: "float",
                        message: "Input must be floating-point number",
                      },
                    ]}
                  >
                    <InputNumber
                      style={{ width: "100%" }}
                      // precision={0.00001}
                      max={89.999999}
                      min={-89.999999}
                      placeholder="-90~90"
                      disabled={!AlarmType?.includes("geofence") || !AlarmEnable}
                    />
                  </Form.Item>
                  <Form.Item
                    name={"gps_longitude"}
                    label="Longitude"
                    rules={[
                      {
                        required: AlarmType?.includes("geofence") && AlarmEnable,
                        message: "required!",
                      },
                      {
                        type: "float",
                        message: "Input must be floating-point number",
                      },
                    ]}
                  >
                    <InputNumber
                      style={{ width: "100%" }}
                      // precision={0.00001}
                      max={179.999999}
                      min={-179.999999}
                      placeholder="-180~180"
                      disabled={!AlarmType?.includes("geofence") || !AlarmEnable}
                    />
                  </Form.Item>
                </Fragment>
              )}
            </Col>
          ) : (
            <Col xs={24} sm={24} md={24} lg={24} xl={10}></Col>
          )}
        </Row>
      </div>
    </Form>
  );
});

export default AlarmM335;

////////////////////////////////////////////

export function assemble(values: any) {
  const model = values.model || "";

  if (model === "M335-W6") {
    let alarm: any = {
      mode: values.alarm_enabled,
      geofence: {
        radius_m: values.gps_radius || 150,
        auto_detect: values.gps_reference || false,
      },
    };

    if (values.alarm_enabled) {
      alarm.inputs = values.alarm_input;
    } else {
      alarm.inputs = ["geofence"];
    }

    if (!values.gps_reference) {
      alarm.geofence.latitude = values.gps_latitude ?? 10.123456;
      alarm.geofence.longitude = values.gps_longitude ?? 10.123456;
    }
    const system = {
      alarm: alarm,
    };

    return system;
  } else {
    let alarm: any = {
      mode: values.alarm_enabled,
    };

    if (values.alarm_enabled) {
      alarm.inputs = values.alarm_input;
    }

    const system = {
      alarm: alarm,
    };

    return system;
  }
}
